module.exports = "/assets/data/5f3822cdfefed774e89bdcaa49217991-WR6.data.json";